import Vue from "vue";
import merge from "lodash.merge";

import getBreakpoints from "@/js/helpers/breakpoint-helper";

const state = Vue.observable({
    navData: {
        "PrimaryItems": [
            {
                "Title": "Study",
                "Url": "https://sc104sc.dev.local/study-here",
                "FirstFeaturedItem": [
                    {
                        "Title": "Find a course",
                        "Url": "https://sc104sc.dev.local/courses",
                        "Image": {
                            "alt": "Postgraduate open day",
                            "height": 394,
                            "width": 700,
                            "link": {
                                "text": "",
                                "title": ""
                            },
                            "src": "https://sc104sc.dev.local/-/media/home/olp/postgraduatestudyfair-edited.jpg?sc_lang=en"
                        }
                    }
                ],
                "SecondFeaturedItem": [
                    {
                        "Title": "Apply",
                        "Url": "https://sc104sc.dev.local/study-here/apply",
                        "Image": {
                            "alt": "Animation of various students posing for selfies",
                            "height": 600,
                            "width": 600,
                            "link": {
                                "text": "",
                                "title": ""
                            },
                            "src": "https://sc104sc.dev.local/-/media/external/emails/welcome-snapchat-takeover.gif?sc_lang=en"
                        }
                    }
                ],
                "NonFeaturedItems": [
                    {
                        "Title": "Online masters degrees",
                        "Url": "https://online.shu.ac.uk"
                    },
                    {
                        "Title": "International students",
                        "Url": "https://sc104sc.dev.local/study-here/international"
                    },
                    {
                        "Title": "Accommodation",
                        "Url": "https://sc104sc.dev.local/study-here/accommodation"
                    },
                    {
                        "Title": "Fees and funding",
                        "Url": "https://sc104sc.dev.local/study-here/fees-and-funding"
                    },
                    {
                        "Title": "Student life",
                        "Url": "https://sc104sc.dev.local/study-here/student-life"
                    },
                    {
                        "Title": "Studying with us",
                        "Url": "https://sc104sc.dev.local/study-here/studying-with-us"
                    },
                    {
                        "Title": "Schools and colleges liaison and outreach",
                        "Url": "https://sc104sc.dev.local/schools-and-colleges-liaison-and-outreach"
                    }
                ]
            },
            {
                "Title": "Research",
                "Url": "https://sc104sc.dev.local/research",
                "FirstFeaturedItem": [
                    {
                        "Title": "Research degrees",
                        "Url": "https://sc104sc.dev.local/research/degrees",
                        "Image": {
                            "alt": null,
                            "height": null,
                            "width": null,
                            "link": null,
                            "src": null
                        }
                    }
                ],
                "SecondFeaturedItem": [
                    {
                        "Title": "Research areas",
                        "Url": "https://sc104sc.dev.local/research/specialisms",
                        "Image": {
                            "alt": null,
                            "height": null,
                            "width": null,
                            "link": null,
                            "src": null
                        }
                    }
                ],
                "NonFeaturedItems": [
                    {
                        "Title": "Our people",
                        "Url": "https://sc104sc.dev.local/research/people"
                    },
                    {
                        "Title": "Research in action",
                        "Url": "https://sc104sc.dev.local/research/in-action"
                    },
                    {
                        "Title": "Contact us",
                        "Url": "https://sc104sc.dev.local/research/contact-us"
                    },
                    {
                        "Title": "Outputs and data",
                        "Url": "https://sc104sc.dev.local/research/outputs-and-data"
                    },
                    {
                        "Title": "Excellence and integrity",
                        "Url": "https://sc104sc.dev.local/research/excellence"
                    }
                ]
            },
            {
                "Title": "Alumni",
                "Url": "https://sc104sc.dev.local/alumni",
                "FirstFeaturedItem": [
                    {
                        "Title": "Exclusive discounts",
                        "Url": "https://sc104sc.dev.local/alumni/exclusive-discounts",
                        "Image": {
                            "alt": null,
                            "height": null,
                            "width": null,
                            "link": null,
                            "src": null
                        }
                    }
                ],
                "SecondFeaturedItem": [
                    {
                        "Title": "Volunteer",
                        "Url": "https://sc104sc.dev.local/alumni/volunteer",
                        "Image": {
                            "alt": null,
                            "height": null,
                            "width": null,
                            "link": null,
                            "src": null
                        }
                    }
                ],
                "NonFeaturedItems": [
                    {
                        "Title": "Award certificates and transcripts",
                        "Url": "https://sc104sc.dev.local/alumni/award-certificates-and-transcripts"
                    },
                    {
                        "Title": "Donate",
                        "Url": "https://sc104sc.dev.local/alumni/donate"
                    }
                ]
            },
            {
                "Title": "Visit us",
                "Url": "https://sc104sc.dev.local/visit-us",
                "FirstFeaturedItem": [
                    {
                        "Title": "Undergraduate open days",
                        "Url": "https://sc104sc.dev.local/visit-us/open-days",
                        "Image": {
                            "alt": null,
                            "height": null,
                            "width": null,
                            "link": null,
                            "src": null
                        }
                    }
                ],
                "SecondFeaturedItem": [
                    {
                        "Title": "Postgraduate open days",
                        "Url": "https://sc104sc.dev.local/visit-us/postgraduate-open-days",
                        "Image": {
                            "alt": null,
                            "height": null,
                            "width": null,
                            "link": null,
                            "src": null
                        }
                    }
                ],
                "NonFeaturedItems": [
                    {
                        "Title": "Campus tours",
                        "Url": "https://sc104sc.dev.local/visit-us/student-led-tours"
                    },
                    {
                        "Title": "How to find us",
                        "Url": "https://sc104sc.dev.local/visit-us/how-to-find-us"
                    },
                    {
                        "Title": "Manage event bookings",
                        "Url": "https://events.shu.ac.uk/login"
                    }
                ]
            },
            {
                "Title": "Business",
                "Url": "https://sc104sc.dev.local/business",
                "FirstFeaturedItem": [
                    {
                        "Title": "Start your business",
                        "Url": "https://sc104sc.dev.local/business/start-your-business",
                        "Image": {
                            "alt": null,
                            "height": null,
                            "width": null,
                            "link": null,
                            "src": null
                        }
                    }
                ],
                "SecondFeaturedItem": [
                    {
                        "Title": "Grow your business",
                        "Url": "https://sc104sc.dev.local/business/grow-your-business",
                        "Image": {
                            "alt": null,
                            "height": null,
                            "width": null,
                            "link": null,
                            "src": null
                        }
                    }
                ],
                "NonFeaturedItems": [
                    {
                        "Title": "Large business support",
                        "Url": "https://sc104sc.dev.local/business/support-for-large-businesses"
                    },
                    {
                        "Title": "Apprenticeships",
                        "Url": "https://sc104sc.dev.local/study-here/higher-and-degree-apprenticeships"
                    },
                    {
                        "Title": "Hire a space",
                        "Url": "https://sc104sc.dev.local/business/event-services"
                    },
                    {
                        "Title": "Upcoming events",
                        "Url": "https://sc104sc.dev.local/business/events"
                    }
                ]
            },
            {
                "Title": "About us",
                "Url": "https://sc104sc.dev.local/about-us",
                "FirstFeaturedItem": [
                    {
                        "Title": "Our people",
                        "Url": "https://sc104sc.dev.local/about-us/our-people",
                        "Image": {
                            "alt": null,
                            "height": null,
                            "width": null,
                            "link": null,
                            "src": null
                        }
                    }
                ],
                "SecondFeaturedItem": [
                    {
                        "Title": "University structure",
                        "Url": "https://sc104sc.dev.local/about-us/academic-departments",
                        "Image": {
                            "alt": null,
                            "height": null,
                            "width": null,
                            "link": null,
                            "src": null
                        }
                    }
                ],
                "NonFeaturedItems": [
                    {
                        "Title": "Who we are",
                        "Url": "https://sc104sc.dev.local/about-us/who-we-are"
                    },
                    {
                        "Title": "Governance",
                        "Url": "https://sc104sc.dev.local/about-us/governance"
                    },
                    {
                        "Title": "Our values",
                        "Url": "https://sc104sc.dev.local/about-us/our-values"
                    },
                    {
                        "Title": "Our role in the region",
                        "Url": "https://sc104sc.dev.local/about-us/our-role-in-the-region"
                    },
                    {
                        "Title": "Strategy",
                        "Url": "https://sc104sc.dev.local/about-us/strategy"
                    }
                ]
            }
        ],
        "AuxillaryItems": [
            {
                "Title": "Online masters",
                "Url": "https://online.shu.ac.uk/",
                "IsCurrent": false
            },
            {
                "Title": "MyHallam",
                "Url": "https://sc104sc.dev.local/myhallam",
                "IsCurrent": false
            },
            {
                "Title": "Staff",
                "Url": "https://sheffieldhallam.sharepoint.com/sites/staffhome",
                "IsCurrent": false
            }
        ]
    },
    breakpoints: getBreakpoints(),
    siteSearchData: {
        formAttrs: {
            method: "POST",
            action: "/api/sitecore/NavigationSearch/NavigationSearchSubmit",
        },
        queryInputAttrs: {
            name: "Request.Query",
            placeholder: "Search our website & courses",
        },
        label: `Search our website &amp; courses`,
    },
});

export const actions = {
    setNavData(data) {
        if (data) {
            state.navData = data;
        }
    },
    mergeSiteSearchData(data) {
        state.siteSearchData = merge(state.siteSearchData, data);
    },
};

export default {
    get state() {
        return state;
    },
    get isDesktop() {
        return state.breakpoints.large;
    },
};
